module.exports = "<nb-actions size=\"small\">\r\n  <nb-action icon=\"color-palette-outline\" (click)=\"openStyle()\"></nb-action>\r\n</nb-actions>\r\n"